import type { I18nPrefix } from '../../i18n/prefix';

export const I18N_PAGE = 'features:customers.pages.customers_sync_page' satisfies I18nPrefix;
export const I18N_DATA_PAGE =
  'features:customers.pages.customer_sync_data_page' satisfies I18nPrefix;
export const I18N_ROLE_CARD =
  'features:customers.components.customer_role_selection_card' satisfies I18nPrefix;

export const CUSTOMERS_SYNC_PATH = '/integrations/customers-sync';

const DOCS_BASE = 'https://docs.sparklayer.io';

export const DOCS_URLS = {
  dataSync: `${DOCS_BASE}/data-sync`,
  dataSyncLookup: `${DOCS_BASE}/data-sync#xzZAy`,
  troubleshooting: `${DOCS_BASE}/troubleshooting#A3ozG`,
} as const;
